// Relative Path: src/js/_marquee.js

import { gsap } from "gsap";
import { Observer } from "gsap/all";

gsap.registerPlugin(Observer);

const marquee = {
	// init() {
	// 	const mm = gsap.matchMedia();
	// 	const containers = gsap.utils.toArray(".c-marquee");

	// 	if (!containers.length) return;

	// 	mm.add("(min-width: 0px)", () => {
	// 		containers.forEach((container) => {
	// 			const scrollingText = container.querySelectorAll(".c-marquee__text");
	// 			if (!scrollingText.length) return;

	// 			const customSpeed = parseFloat(container.dataset.speed) || 1;

	// 			const tl = this.horizontalLoop(scrollingText, {
	// 				repeat: -1,
	// 				// paddingRight: 30,
	// 				speed: customSpeed,
	// 			});

	// 			Observer.create({
	// 				target: window,
	// 				onChangeY(self) {
	// 					let factor = 1.25;
	// 					if (self.deltaY < 0) factor *= -1;

	// 					gsap
	// 						.timeline({ defaults: { ease: "none" } })
	// 						.to(tl, {
	// 							timeScale: factor * 2.5,
	// 							duration: 0.2,
	// 							overwrite: true,
	// 						})
	// 						.to(tl, { timeScale: factor / 2.5, duration: 1 }, "+=0.3");
	// 				},
	// 			});
	// 		});

	// 		return () => {
	// 			gsap.killTweensOf(".c-marquee__text");
	// 		};
	// 	});
	// },

	init() {
		const containers = gsap.utils.toArray(".c-marquee");
		if (!containers.length) return;

		containers.forEach((container) => {
			const rail = container.querySelector(".c-marquee__rail");
			const originalText = rail.querySelector(".c-marquee__text");
			if (!originalText) return;

			let tl;

			const setup = () => {
				// 1. Kill animazione precedente se esiste
				if (tl) {
					tl.kill();
					gsap.set(rail.querySelectorAll(".c-marquee__text"), { clearProps: "all" });
				}

				// 2. Rimuovi cloni precedenti (lascia solo il primo)
				const currentTexts = rail.querySelectorAll(".c-marquee__text");
				currentTexts.forEach((el, i) => { if (i !== 0) el.remove(); });

				// 3. Calcola quanti ne servono
				const containerWidth = container.offsetWidth;
				const textWidth = originalText.offsetWidth;

				// Formula: Larghezza contenitore / larghezza testo + 2 di buffer per sicurezza
				const repeatCount = Math.ceil(containerWidth / textWidth) + 2;

				for (let i = 0; i < repeatCount; i++) {
					const clone = originalText.cloneNode(true);
					rail.appendChild(clone);
				}

				// 4. Avvia il loop
				const items = rail.querySelectorAll(".c-marquee__text");
				const customSpeed = parseFloat(container.dataset.speed) || 1;

				tl = this.horizontalLoop(items, {
					repeat: -1,
					speed: customSpeed,
					paddingRight: 0 // Gestito da CSS (es. 1ch o gap)
				});
			};

			// Inizializzazione al caricamento (attendi i font per avere larghezze corrette)
			window.addEventListener("load", setup);

			// Gestione Resize con debounce leggero
			let resizeTimeout;
			window.addEventListener("resize", () => {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(setup, 200);
			});

			// Observer per lo scroll (opzionale, mantiene la tua logica precedente)
			this.addScrollObserver(tl);
		});
	},

	addScrollObserver(timeline) {
		Observer.create({
			target: window,
			onChangeY(self) {
				if (!timeline) return;
				let factor = 1.25;
				if (self.deltaY < 0) factor *= -1;

				gsap.timeline({ defaults: { ease: "none" } })
					.to(timeline, { timeScale: factor * 2.5, duration: 0.2, overwrite: true })
					.to(timeline, { timeScale: factor / 2.5, duration: 1 }, "+=0.3");
			},
		});
	},

	horizontalLoop(items, config) {
		items = gsap.utils.toArray(items);
		config = config || {};

		const tl = gsap.timeline({
			repeat: config.repeat,
			paused: config.paused,
			defaults: { ease: "none" },
			onReverseComplete: () =>
				tl.totalTime(tl.rawTime() + tl.duration() * 100),
		}),
			length = items.length,
			startX = items[0].offsetLeft,
			times = [],
			widths = [],
			xPercents = [],
			pixelsPerSecond = (config.speed || 1) * 100,
			snap =
				config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1);

		// Initial setup
		gsap.set(items, {
			xPercent: (i, el) => {
				const w = parseFloat(gsap.getProperty(el, "width", "px"));
				widths[i] = w; // Separated assignment

				const x = parseFloat(gsap.getProperty(el, "x", "px"));
				const xp = gsap.getProperty(el, "xPercent");

				xPercents[i] = snap((x / w) * 100 + xp);
				return xPercents[i];
			},
		});

		gsap.set(items, { x: 0 });

		// Calculate total width safely
		const lastItem = items[length - 1];
		const lastWidth = widths[length - 1];
		const lastXPerc = xPercents[length - 1];
		const lastScaleX = gsap.getProperty(lastItem, "scaleX");
		const padding = parseFloat(config.paddingRight) || 0;

		const totalWidth =
			lastItem.offsetLeft +
			(lastXPerc / 100) * lastWidth -
			startX +
			lastItem.offsetWidth * lastScaleX +
			padding;

		for (let i = 0; i < length; i++) {
			const item = items[i];
			const curX = (xPercents[i] / 100) * widths[i];
			const distanceToStart = item.offsetLeft + curX - startX;
			const distanceToLoop =
				distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");

			tl.to(
				item,
				{
					xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
					duration: distanceToLoop / pixelsPerSecond,
				},
				0,
			)
				.fromTo(
					item,
					{
						xPercent: snap(
							((curX - distanceToLoop + totalWidth) / widths[i]) * 100,
						),
					},
					{
						xPercent: xPercents[i],
						duration:
							(curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
						immediateRender: false,
					},
					distanceToLoop / pixelsPerSecond,
				)
				.add(`label${i}`, distanceToStart / pixelsPerSecond);

			times[i] = distanceToStart / pixelsPerSecond;
		}

		return tl;
	},
};

export default marquee;
